__turbopack_context__.v({
  "contentWrapper": "planselect-module-scss-module__gsgCLW__contentWrapper",
  "overrideText": "planselect-module-scss-module__gsgCLW__overrideText",
  "sectionHeader": "planselect-module-scss-module__gsgCLW__sectionHeader",
  "selectColumn": "planselect-module-scss-module__gsgCLW__selectColumn",
  "selectGroup": "planselect-module-scss-module__gsgCLW__selectGroup",
  "selectWrapper": "planselect-module-scss-module__gsgCLW__selectWrapper",
  "tableBody": "planselect-module-scss-module__gsgCLW__tableBody",
  "tableHeader": "planselect-module-scss-module__gsgCLW__tableHeader",
  "tableHeaderWrapper": "planselect-module-scss-module__gsgCLW__tableHeaderWrapper",
  "tableWrapper": "planselect-module-scss-module__gsgCLW__tableWrapper",
  "tooltipContent": "planselect-module-scss-module__gsgCLW__tooltipContent",
});
